import React, { useState, useEffect, useRef } from 'react';
import { compose } from 'redux';
import { IconButton, Input } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const NameInput = ({ classes, name, invertColor, onSave }) => {
  // == REFERENCES ==========================================

  const inputRef = useRef(null);

  // == STATE ===============================================

  const [myName, setMyName] = useState(name);

  // == EFFECTS =============================================

  useEffect(() => {
    console.log(inputRef);
    inputRef.current && inputRef.current.focus();
  }, []);

  // == EVENT HANDLERS =====================================

  const handleRenameSave = (e) => {
    onSave(myName);
  };

  // == COMPONENT ==========================================

  return (
    <>
      <Input
        inputRef={inputRef}
        value={myName}
        margin='dense'
        classes={{
          root: classNames(
            classes.editNameInputRoot,
            invertColor && classes.invertedColors
          ),
          input: classes.editNameInput,
        }}
        onBlur={(e) => console.log(e)}
        onChange={(e) => setMyName(e.target.value)}
        style={{ fontSize: '1.2rem' }}
      />
      <IconButton
        color='inherit'
        className={classes.moreButton}
        onClick={handleRenameSave}
      >
        <CheckIcon />
      </IconButton>
    </>
  );
};

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 4px',
    backgroundColor: '#cbcbcb',
    borderBottom: '1px solid #b7b7b7',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
  },
  headerRight: {
    display: 'flex',
  },
  openedList: {
    paddingTop: 8,
    paddingBottom: 8,
    backgroundColor: '#f2f2f2',
    transition: 'background-color 0.2 ease',
    overflowY: 'auto',
    borderBottom: '1px solid #b7b7b7',
  },
  expandButton: {
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    padding: 2,
    marginRight: 6,
  },
  visibilityButton: {
    padding: 2,
  },
  moreButton: {
    padding: 2,
    marginLeft: 6,
  },
  editNameInputRoot: {
    color: 'inherit',
    fontWeight: 500,
    width: 250,
    '& .MuiInput-underline': {
      marginLeft: 2,
    },
  },
  editNameInput: {
    paddingBottom: 4,
  },
  invertedColors: {
    '&::before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.55)',
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.55)',
    },
    '&::after': {
      borderBottomColor: 'rgba(255, 255, 255, 0.7)',
    },
  },
};

export default compose(withStyles(styles))(NameInput);
